import _ from 'lodash';
export const makeFilterOptionsComponentClass = (name) => {
    const componentName = 'filter-options';
    if (typeof name === 'string' || typeof name === 'number') {
        return `${componentName}__${name}`;
    }
    if (_.isArray(name)) {
        return name
            .filter((item) => typeof item === 'string' || typeof item === 'number')
            .map((item) => `${componentName}__${item}`)
            .join(' ');
    }
    return '';
};
export const makeNoResultsComponentClass = (name = '') => {
    return `no-filter-results__${name}`;
};
